/* eslint-disable replo/no-tailwind-literal-color */
import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { useStickToBottomContext } from "use-stick-to-bottom";

const ScrollToBottomButton: React.FC = () => {
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();

  if (isAtBottom) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      size="sm"
      UNSAFE_className="absolute bottom-2 right-2 shadow"
      onClick={() => void scrollToBottom()}
    >
      Scroll to bottom
    </Button>
  );
};

export { ScrollToBottomButton };
